import { Component } from "react";
import { Link } from "react-router-dom";

const subtitle = "We love";
const title = "OUR PARTNERS";
const btnText = "BECOME A PARTNER";
const para =
  "We are proud to work with partners representing industry-leading brands as part of the F9 family. Our goal is to work closely and collaboratively with partners to improve the esports entertainment experience for all.";

class SponsorSectionAbout extends Component {
  render() {
    return (
      <div className="sponsor-section padding-top ">
        <div className="container">
          {/* SECTION HEADER */}
          <div className="section-header text-center">
            <p>{subtitle}</p>
            <h2 className="text-anim-typing  js-animate delay-md">{title}</h2>
            <h4 className="text-anim-fade-down js-animate delay-md">{para}</h4>
          </div>

          {/* SPONSORS */}
          <div className="section-wrapper">
            <div className="row justify-content-center sponsor-row">

              {/* FRUUM */}
              <div className="col-auto">
                <div className="sponsor-item">
                  <img
                    src="assets/images/sponsor/sponsor1.png"
                    alt="Fruum"
                    className="sponsor-logo sponsor-fruum"
                  />
                </div>
              </div>

              {/* REMOTE INTEGRITY */}
              <div className="col-auto">
                <div className="sponsor-item">
                  <img
                    src="assets/images/sponsor/sponsor2.png"
                    alt="Remote Integrity"
                    className="sponsor-logo sponsor-remote"
                  />
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default SponsorSectionAbout;
